module.exports = __webpack_public_path__ + "assets/icon-search-component.ccb73a36.svg";